import { GET, POST } from "@/services/request";
import * as APIs from '@/services/APIs';

export const fetchShoppingList = async (params) => {
  const res = await GET(APIs.API_SUBSCRIBE_SHOPPING_LIST, { params })
  return res.data.data ?? {};
}

/**
 * 获取购物袋记录
 * @returns 
 */
export const fetchBags = async (params) => {
  const res = await GET(APIs.API_SUBSCRIBE_SHOPPING_BAGS, { params })
  return res.data.data ?? {};
}

/**
 * 添加购物袋
 * @returns 
 */
export const fetchAddBags = async (data) => {
  const res = await POST(APIs.API_SUBSCRIBE_SHOPPING_BAGS_ADD, { data })
  return res.data ?? {};
}

/**
 * 确认取货
 * @returns 
 */
export const fetchPick = async (data) => {
  const res = await POST(APIs.API_SUBSCRIBE_SHOPPING_PICK, { data })
  return res.data ?? {};
}

/**
 * 免提购物详情
 */
export const fetchShoppingInfo = async (service_id) => {
  const res = await GET(APIs.API_SERVICE_HANDSFREEINFO, { params: { service_id } });

  return res.data.data ?? {};
};

/**
 * 编辑免提购物
 */
export const fetchEditShopping = async (data) => {
  const res = await POST(APIs.API_SERVICE_EDITHANDSFREE, { data });

  return res.data.data ?? {};
};
